<template>
  <div v-if="isMounted">
    <div class="vx-col w-full mb-3">
      <vs-collapse type="border">
        <vs-collapse-item>
          <div slot="header">Filters</div>
          <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <form >
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <component :appendToBody="appendToBody" :is="fName[1].type" :structure="fName[1]"
                    v-for="(fName) in showFormFields[0]" :key="fName[0] + status" :index="fName[0]"
                    :value="showValue(fName[0])" @input="(data) => inputParams[data.index] = data.value"></component>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <component :appendToBody="appendToBody" :is="fName[1].type" :structure="fName[1]"
                    v-for="(fName) in showFormFields[1]" :key="fName[0] + status" :index="fName[0]"
                    :value="showValue(fName[0])" @input="(data) => inputParams[data.index] = data.value"></component>
                </div>
              </div>
              <div class="flex flex-wrap items-center pt-5 pb-5" slot="footer">
                <vs-button class="mr-6" @click="filterNow()">Filter Now</vs-button>
                <vs-button type="border" class="mr-6" color="warning" @click="reset()">Reset</vs-button>
                <vs-button v-if="endPoint != 'getWarehouseDataForInventory'" type="border" color="success"
                  @click="print()">Print</vs-button>
              </div>
            </form>
          </component>
        </vs-collapse-item>
      </vs-collapse>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
import { mapGetters } from "vuex";

import aronTextbox from "../formElements/textbox";
import aronInteger from "../formElements/integer";
import aronPassword from "../formElements/password";
import aronSelect from "../formElements/select";
import aronSelectMasterStockCode from "../formElements/aronSelectMasterStockCode";
import aronMultiSelect from "../formElements/multiselect";
import aronRadio from "../formElements/radio";
import aronRadioStatic from "../formElements/radioStatic";
import aronTextarea from "../formElements/textArea";
import aronCurrency from "../formElements/currency";
import aronNumber from "../formElements/number";
import aronDate from "../formElements/date";
import customDate from "../formElements/customDate";
import aronYearOnly from "../formElements/yearOnly";
import aronFile from "../formElements/file";
import aronDateRange from "../formElements/aronDateRange";

import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {
    aronTextbox,
    aronPassword,
    aronSelect,
    aronSelectMasterStockCode,
    aronMultiSelect,
    aronRadio,
    aronRadioStatic,
    aronTextarea,
    aronCurrency,
    aronNumber,
    aronDate,
    aronDateRange,
    aronYearOnly,
    aronFile,
    aronInteger,
    VuePerfectScrollbar,
    customDate
  },

  methods: {
    filterNow() {
      this.$emit("submit", this.inputParams);
      this.status = "submit";
    },
    print() {
      this.$emit("print", this.inputParams);
      this.status = "submit";
    },
    reset() {
      this.$emit("submit", {});
      this.inputParams = {};
      this.status = "reset";
    },
    showValue(colName) {
      return this.inputParams[colName];
    },
    collapse(event) {
      console.log("eventsss:", event);
    }
  },
  data() {
    return {
      appendToBody: true,
      status: "normal",
      baseUrl: axios.defaults.baseURL,
      isMounted: false,
      currentView: "list",
      inputParams: {},
      errorParams: [],
      data: {},
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },

    };
  },
  props: {
    endPoint: {
      type: String,
      default: ""
    },
  },
  computed: {
    ...mapGetters({
      getUserInfo: "auth/getUserInfo",
      getOrigCurrentDataStructure: "profile/getOrigCurrentDataStructure",
      getOrigDataStructure: "profile/getOrigDataStructure",
      scrollbarTag: "main/scrollbarTag"
    }),

    showFormFields() {
      try {
        console.log(
          "childDataMarker:",
          this.$store.state.profile.childDataMarker
        );

        var dataFilter = _.pickBy(this.getOrigDataStructure, function (st) {
          if (st.hasOwnProperty("showAsFilter")) {
            return st.showAsFilter.toLowerCase() == "yes";
          }
        });

        if (this.$store.state.profile.childDataMarker == "child") {
          console.log("current struc:", this.getOrigCurrentDataStructure);

          dataFilter = _.pickBy(this.getOrigCurrentDataStructure, function (st) {
            if (st.hasOwnProperty("showAsFilter")) {
              return st.showAsFilter.toLowerCase() == "yes";
            }
          });
        }

        console.log("dataFilter:", dataFilter);

        var objCount = Math.ceil(Object.entries(dataFilter).length / 2);
        console.log("objCount:", objCount);
        const arrayFromObject = Object.entries(dataFilter);
        return _.chunk(arrayFromObject, objCount);
      } catch (exception) {
        console.error(exception);
      }
    }
  },
  // 1. fil
  created() { },
  mounted() {
    if (this.showFormFields.length > 0) {
      this.isMounted = true;
    } else {
      this.isMounted = false;
    }
    console.log("showFormFields:", this.showFormFields);
  }
};
</script>
